import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { AbstractControl, FormControl, FormGroup } from '@angular/forms';


@Component({
  selector: 'lib-required-fields',
  templateUrl: './required-fields.component.html',
  styleUrls: ['./required-fields.component.css']
})
export class RequiredFieldsComponent  implements OnInit {
  @Input() formGroup!: FormGroup;
  @Input() translationsSupported?: boolean;
  showRequiredFieldsGuidance: boolean = false;

  constructor() {
    
  }
  ngOnInit(): void {

    for (const field in this.formGroup.controls) { // 'field' is a string

      const control = this.formGroup.get(field) as AbstractControl;

      if(this.isRequiredField(control)){
        this.showRequiredFieldsGuidance = true;
      }
    
    }
  }

  public isRequiredField = (control: AbstractControl): boolean => {
    const { validator } = control
    if (validator) {
        const validation = validator(new FormControl())
        return validation !== null && validation.required === true
    }
    return false
  };

}
